module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0045.jpg?v=cde16793";